import request from '@/utils/request'
import api from '@/api'
import { arrayObjectSort, translateDataToTree } from '@/utils'
import store from '@/store'

const state = () => ({
  // key value 方式显示 {code: name}
  dictionary: {},
  // 转换为树状结构的data
  dictionaryTree: [],
})
const getters = {
  getDictionary(state) {
    return state.dictionary
  },
  getDictionaryTree(state) {
    return state.dictionaryTree
  },
  getDictionaryTreeByKey(state) {
    return function (key) {
      if (key) {
        let tmp = null
        state.dictionaryTree.forEach((item) => {
          if (item.ConfigCode === key) {
            tmp = item
          }
        })
        return tmp
      }
    }
  },
  async getH5Url() {
    let H5Host = api.H5Host
    // todo config后面要去掉 zeyu/survey/
    //SurveyHost = SurveyHost.substr(0, SurveyHost.indexOf('.com/') + 5)
    let tenant = await store.getters['user/getTenant']
    const code = tenant.TenantCode
    const url = `${H5Host}${code}/`
    return url
  },
}

const mutations = {
  setDictionary(state, data) {
    state.dictionary = data
  },
  setDictionaryTree(state, data) {
    state.dictionaryTree = data
  },
}

const actions = {
  IndustryGetAll(context, params) {
    return request({
      url: api.IndustryGetAll,
      method: 'GET',
      params,
    })
  },

  DictionaryGetAll(context, params) {
    return new Promise((resolve, reject) => {
      request({
        url: api.DictionaryGetAll + '?rand=' + Math.random(),
        method: 'GET',
        params,
      })
        .then(({ Data, Code, Message }) => {
          if (Code === 0) {
            const dictionary = {}

            arrayObjectSort(Data, 'Sort')
            Data.forEach((item) => {
              item.id = item.DicId
              dictionary[item.ConfigCode] = item.ConfigName
            })

            context.commit('setDictionary', dictionary)
            let d = translateDataToTree(
              Data,
              'TypeCode',
              'matedata',
              'ConfigCode'
            )
            context.commit('setDictionaryTree', d)
            resolve(d)
          } else {
            reject({ Data, Code, Message })
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  GetAgreementInfo(context, params) {
    return request({
      url: api.GetAgreementInfo,
      method: 'GET',
      params,
    })
  },
  GetProvinceCityTree(context, params) {
    return request({
      url: api.GetProvinceCityTree,
      method: 'GET',
      params,
    })
  },
  ConsultationSheetSubmitCallback(context, params) {
    return request({
      url: api.ConsultationSheetSubmitCallback,
      method: 'POST',
      data: params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
